import React from 'react';
import PropTypes from 'prop-types';

// This will be further updated in the ticket https://anfcorp.atlassian.net/browse/PRO-561

const propTypes = {
  isLoading: PropTypes.bool,
  children: PropTypes.node,
  className: PropTypes.string,
  // eslint-disable-next-line react/forbid-prop-types
  styles: PropTypes.object,
};

const defaultProps = {
  children: null,
  className: undefined,
  isLoading: false,
  styles: undefined,
};

export default function Loading({
  children,
  className,
  isLoading,
  styles,
}) {
  return (
    <div
      className={`loading-animation ${className}`}
      data-testid="loading-animation"
      data-loading={isLoading}
      style={styles}
    >
      { children }
    </div>
  );
}

Loading.defaultProps = defaultProps;
Loading.propTypes = propTypes;
